import React from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from './layouts/full/shared/loadable/Loadable';
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";

/* ***Layouts**** */
const FullLayout = Loadable(React.lazy(() => import('./layouts/full/FullLayout')));
const BlankLayout = Loadable(React.lazy(() => import('./layouts/blank/BlankLayout')));

/* ****Pages***** */
const Dashboard = Loadable(React.lazy(() => import('./views/dashboard/Dashboard')))
const Playlist = Loadable(React.lazy(() => import('./views/playlist')))
const PlaylistTracks = Loadable(React.lazy(() => import('./views/playlist/tracks')))
const Search = Loadable(React.lazy(() => import('./views/search')))
const SearchResult = Loadable(React.lazy(() => import('./views/search/result')))
const Chart = Loadable(React.lazy(() => import('./views/chart')))
const Debut = Loadable(React.lazy(() => import('./views/debut')))
const DebutArtist = Loadable(React.lazy(() => import('./views/debut/artist')))
const DebutSpotifyPlaylist = Loadable(React.lazy(() => import('./views/debut/spotifyplaylist')))
const Watchlist = Loadable(React.lazy(() => import('./views/watchlist')))
const WatchlistAdd = Loadable(React.lazy(() => import('./views/watchlist/add')))
const WatchlistRemove = Loadable(React.lazy(() => import('./views/watchlist/remove')))
const Blacklist = Loadable(React.lazy(() => import('./views/blacklist')))
const BlacklistAdd = Loadable(React.lazy(() => import('./views/blacklist/add')))
const BlacklistRemove = Loadable(React.lazy(() => import('./views/blacklist/remove')))
const Email = Loadable(React.lazy(() => import('./views/email')))
const Stream = Loadable(React.lazy(() => import('./views/stream')))

const Icons = Loadable(React.lazy(() => import('./views/icons/Icons')))
const TypographyPage = Loadable(React.lazy(() => import('./views/utilities/TypographyPage')))
const Shadow = Loadable(React.lazy(() => import('./views/utilities/Shadow')))
const Error = Loadable(React.lazy(() => import('./views/authentication/Error')));
const Register = Loadable(React.lazy(() => import('./views/authentication/Register')));
const Login = Loadable(React.lazy(() => import('./views/authentication/Login')));
const Forgot = Loadable(React.lazy(() => import('./views/authentication/Forgot')));
const Profile = Loadable(React.lazy(() => import('./views/profile')));

// localStorage.setItem("tokenme", `4b9d9232b9327346a7ded4a505db2f97`);
// localStorage.removeItem('tokenme');
const Router = [
  {
    path: '/',
    element: <PrivateRoute element={<FullLayout />} />,
    children: [
      { path: '/', element: <Navigate to="/dashboard" /> },
      { path: '/dashboard', exact: true, element: <Dashboard /> },
      { path: '/playlist', exact: true, element: <Playlist /> },
      { path: '/playlist/:chart/:id', exact: true, element: <PlaylistTracks /> },
      { path: '/search', exact: true, element: <Search /> },
      { path: '/searchresult', exact: true, element: <SearchResult /> },
      { path: '/chart', exact: true, element: <Chart /> },
      { path: '/debut', exact: true, element: <Debut /> },
      { path: '/debutartist', exact: true, element: <DebutArtist /> },
      { path: '/debutspotifyplaylist', exact: true, element: <DebutSpotifyPlaylist /> },
      { path: '/watchlist/artist', exact: true, element: <Watchlist /> },
      { path: '/watchlist/artist/add', exact: true, element: <WatchlistAdd /> },
      { path: '/watchlist/artist/remove', exact: true, element: <WatchlistRemove /> },
      { path: '/blacklist/:type', exact: true, element: <Blacklist /> },
      { path: '/blacklist/:type/add', exact: true, element: <BlacklistAdd /> },
      { path: '/blacklist/:type/remove', exact: true, element: <BlacklistRemove /> },
      { path: '/email', exact: true, element: <Email /> },
      { path: '/stream', exact: true, element: <Stream /> },
      { path: '/icons', exact: true, element: <Icons /> },
      { path: '/ui/typography', exact: true, element: <TypographyPage /> },
      { path: '/ui/shadow', exact: true, element: <Shadow /> },
      { path: '/profile', exact: true, element: <Profile /> },
      { path: '*', element: <Navigate to='/404' /> },
    ],
  },
  {
    path: '/auth',
    element: <PublicRoute element={<BlankLayout />} />,
    children: [
      
      { path: '/auth/register', element: <Register /> },
      { path: '/auth/login', element: <Login /> },
      { path: '/auth/forgot', element: <Forgot /> },
      { path: '*', element: <Navigate to='/404' /> },
    ],
  },
  { path: '/404', element: <Error /> },
];

export default Router;
